import { AlertTriangle } from 'lucide-react';
import Modal from '@/components/ui/Modal';
import Button from '@/components/ui/Button';

interface ExitConfirmModalProps {
  visible: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  answeredCount: number;
  totalQuestions: number;
}

export default function ExitConfirmModal({
  visible,
  onCancel,
  onConfirm,
  answeredCount,
  totalQuestions,
}: ExitConfirmModalProps) {
  return (
    <Modal visible={visible} onClose={onCancel}>
      <div className="flex flex-col items-center text-center">
        <div className="w-14 h-14 rounded-full bg-warning/10 flex items-center justify-center mb-4">
          <AlertTriangle size={28} className="text-warning" />
        </div>
        <h2 className="font-display font-semibold text-xl text-text-primary mb-2">
          Leave the test?
        </h2>
        <p className="font-sans text-sm text-text-secondary mb-6">
          You've answered {answeredCount} of {totalQuestions} questions. Your
          progress will be lost.
        </p>
        <div className="flex flex-col gap-3 w-full">
          <Button onClick={onCancel} fullWidth>
            Keep Going
          </Button>
          <Button variant="ghost" onClick={onConfirm} fullWidth>
            <span className="text-error">Leave Test</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
}
